import { For, createEffect } from "solid-js";
import Layout from "@/Layout/Layout";
import FeaturedDealer from "./app/FeaturedDealer/FeaturedDealer";
import {
  AppRefreshProvider,
  useAppRefresh,
} from "./contexts/app-refresh/app-refresh.context";
import { GlobalErrorCatcher } from "@/components/global-error-catcher/GlobalErrorCatcher";
import { MFE_EVENTS } from "@/shared/constants/event.const";
import { emitMfeEvent } from "@/utils/event.utils";
import {
  setDealerContext,
  setAlternateCustomerIdContext,
} from "@/services/stratum.service";

export interface CancelCampaignParams {
  month: number;
  year: number;
}

export interface Permission {
  groupID: string;
  permissionID: string;
  accessType: string;
  shadowedAccessType: string;
  permissionName: string;
  value: string;
  permissionLookupID: string;
}

export interface FeaturedDealerMFEProps {
  dealerId: string;
  userId: string;
  userIsAdmin: boolean;
  featureToggles: Record<string, boolean>;
  cancelCampaign?: CancelCampaignParams;
  permissions?: Record<string, Permission>;
}

const MainContent = (props: FeaturedDealerMFEProps) => {
  let rootRef: HTMLDivElement | undefined;
  const { refreshKey } = useAppRefresh();

  createEffect(() => setDealerContext(props.dealerId));
  createEffect(() => setAlternateCustomerIdContext(props.userId));

  const exitFeaturedDealer = () => {
    if (rootRef) {
      emitMfeEvent(rootRef, MFE_EVENTS.EXIT_MARKETING_CHANNEL, {
        channel: "FEATURED_DEALER",
        message: "User has exited featured dealer",
        timestamp: new Date(),
      });
    }
  };

  const originalProps = {
    dealerId: props.dealerId,
    userId: props.userId,
    userIsAdmin: props.userIsAdmin,
    featureToggles: props.featureToggles,
    cancelCampaign: props.cancelCampaign,
    permissions: props.permissions,
  };

  return (
    <div ref={rootRef} class="@container">
      <GlobalErrorCatcher onExit={exitFeaturedDealer}>
        {/* Everytime refreshKey changes, the FeaturedDealer will be remounted */}
        <For each={[refreshKey()]}>
          {() => (
            <Layout>
              <FeaturedDealer
                dealerId={originalProps.dealerId}
                userId={originalProps.userId}
                userIsAdmin={originalProps.userIsAdmin}
                featureToggles={originalProps.featureToggles}
                cancelCampaign={originalProps.cancelCampaign}
                permissions={originalProps.permissions}
                exitFeaturedDealer={exitFeaturedDealer}
              />
            </Layout>
          )}
        </For>
      </GlobalErrorCatcher>
    </div>
  );
};

const Main = (props: FeaturedDealerMFEProps) => {
  return (
    <AppRefreshProvider>
      <MainContent {...props} />
    </AppRefreshProvider>
  );
};

export default Main;
